module.exports = __webpack_public_path__ + "img/17-OTJS-make-the-most-of-your-work-experience.18790ed0.svg";